import { IRootState } from '..'

export const getPromoter = (state: IRootState, id: string) =>
  state.promoterState.promoters.filter(promoter => promoter.id === id)[0]
